import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-6 lg:gap-8',
    block: '',
    actions: 'flex justify-between gap-4',
    labels: 'flex flex-wrap gap-1',
    share: '',
    stock:
      'heading-xs relative mb-4 pl-4 before:absolute before:top-1/2 before:-left-0 before:block before:h-2.5 before:w-2.5 before:-translate-y-1/2 before:transform before:rounded-full',
    addToCart: 'flex-1',
    wishlist: 'flex-center flex size-[50px]',
    wishlistIcon: 'size-6 md:size-8',
    price: 'mb-[5px] items-baseline',
    loyalty: '',
    name: 'flex flex-col',
    nameText: 'block',
    shortDescription: 'block',
    image: 'bg-blue-light',
    link: 'heading-xs-bold tracking-[0.06em] uppercase',

    info: ''
  },
  variants: {
    catalog: {
      true: {
        labels: 'mb-2',
        nameText: 'heading-m lg:heading-xl mb-1',
        shortDescription: 'heading-xs lg:heading-s',
        image: 'h-25 w-25 lg:h-30 lg:w-30',
        info: 'mb-4 flex gap-5'
      },
      false: {
        labels: 'mb-2.5 lg:mb-4',
        nameText: 'heading-2xl lg:heading-3xl mb-2',
        shortDescription: 'heading-s lg:heading-m mb-2.5 lg:mb-5.5'
      }
    },
    outOfStock: {
      true: {
        stock: 'before:bg-[#E25444]',
        price: 'opacity-50',
        loyalty: 'opacity-50'
      },
      false: {
        stock: 'before:bg-[#34AD69]'
      }
    }
  }
});
